import React, {Component} from 'react';

export default class Transport extends Component {
    render() {
        return (
            <div>
                <h2>Flights</h2>
                <p>
                    There are a range of flights to Marrakech, Essaouira and Agadir for more information check out
                    airlines such as Easyjet, Ryanair, Royal Air Maroc and British Airways. Websites such as Skyscanner
                    are also great for looking into options.
                </p>
                <br/>

                <h2>Local Transport</h2>
                <p><b>Transfer</b> - Upon request, Sandra may arrange tranfers
                    to and from the riad.</p>
                <p><b>Coach</b> - On arrival in Marrakech, it&#39;s easy to get
                    to Essaouira. Supratours (<a href="http://www.supratours.ma">www.supratours.ma</a>) operate a coach
                    service 4 times a day for around £5 each way (approx. DH 70). They operate the service from next to
                    the train station. The address and telephone number for Supratours Marrakech is:</p>
                <ul>
                    <li>SUPRATOURS MARRAKECH</li>
                    <li>AV. HASSAN II, GARE ONCF</li>
                    <li>MARRAKECH</li>
                    <li>Tel: 00 212 44 435 525 / 44 436 331</li>
                    <li>Fax: 00 212 44 430 201</li>
                </ul>
                <p><b>Local Buses</b> - All local bus services leave from Marrakech&#39;s
                    central bus station at Place El Mouarabitène, just outside Bab Doukkala on the north-western edge of
                    the old city. Fares are charged per passenger and should be paid directly to the driver. The bus
                    journey takes approximately 2hrs.45mins and the scenery, once out of Marrakech, is stunning and the
                    bus journey is well worth it.</p>
                <p><b>Taxis</b> - cost about £42 from Marrakech (DH 700) and from £80 (DH 1100)
                    for a minibus, and take approximately 2hrs.15mins. We will happily organise a taxi to meet you at
                    the airport and drive you and your guests directly to Essaouira where we will meet you at the gates
                    of the city.</p>
                <p><b>Car hire</b> - costs about £35 a day (DH 500).</p>
            </div>
        );
    }
}